module.exports = __webpack_public_path__ + "img/home-certification-03.59509524.png";